import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getAgreement(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createAgreement(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/agreement" + pathname, body);
}

export async function updateAgreement(
  pathname,
  queryParams,
  body) {
  return await instance({
    baseURL: baseURL,
  }).post("/agreement" + pathname + queryParams, body);
}

export async function deleteAgreement(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/agreement" + pathname + queryParams);
}
